import { mapState } from 'vuex'

export default {
    layout: 'empty',

    fetch() {
        this.$store.dispatch('jsonloader/fetchJson', 'forms.json')
    },

    computed: {
        ...mapState({
            forms: (state) => state.jsonloader.data['forms.json'] || null,
        }),

        content() {
            return this.forms?.find((el) => el.slug === this.$route.params.slug) || []
        },

        siteMeta() {
            const metaInfo = { meta: [] }
            if (this.content?.meta) {
                if (this.content.meta.title) {
                    this.$set(metaInfo, 'title', this.content.meta.title)
                    this.$set(metaInfo, 'meta', [
                        ...metaInfo.meta,
                        { property: 'title', hid: 'title', content: this.content.meta.title },
                        { property: 'og:title', hid: 'og:title', content: this.content.meta.title },
                        { property: 'og:site_name', hid: 'og:site_name', content: this.content.meta.title },
                    ])
                }
                if (this.content.meta.description) {
                    this.$set(metaInfo, 'meta', [
                        ...metaInfo.meta,
                        { name: 'description', hid: 'description', content: this.content.meta.description },
                        { property: 'og:description', hid: 'og:description', content: this.content.meta.description },
                    ])
                }
                if (this.content.meta.image)
                    this.$set(metaInfo, 'meta', [
                        ...metaInfo.meta,
                        { hid: 'image', name: 'image', content: this.content.meta.image },
                        { hid: 'og:image', property: 'og:image', content: this.content.meta.image },
                    ])
            }
            return metaInfo
        },
    },

    watch: {
        content: {
            handler() {
                if (!this.content.slug) this.$router.push({ name: 'index' })
            },
        },
    },

    head() {
        return this.siteMeta
    },
}
